import React from "react";
//
import { Container } from "@mantine/core";
//
import type { Question } from "@neuromotion-inc/mightier-survey-engine";
import type { SurveyEngineIface } from "src/services/surveyHooks/useSurveyEngine";
import { SurveyRichText } from "../survey-rich-text/survey-rich-text";
// tyles
import css from "./survey-question-text.module.css";

interface SurveyQuestionTextProps {
  required: boolean;
  questionText: Question["question_text"];
  surveyEngine: SurveyEngineIface;
}

export const SurveyQuestionText = React.memo<SurveyQuestionTextProps>(
  function SurveyQuestionText(props) {
    const { questionText, surveyEngine, required } = props;

    return (
      <Container
        fluid
        mb="lg"
        style={{ display: "flex", flexDirection: "column" }}
      >
        {questionText.title ? (
          <div
            className={css["title-text"]}
            style={{ display: "flex", alignItems: "center" }}
          >
            <SurveyRichText
              text={questionText.title}
              surveyEngine={surveyEngine}
              style={{ fontSize: "26px", fontWeight: "bold" }}
            />
            {required && (
              <span style={{ color: "red", marginLeft: "4px" }}>*</span>
            )}
          </div>
        ) : null}

        {questionText.description ? (
          <SurveyRichText
            text={questionText.description}
            className={css["description-text"]}
            surveyEngine={surveyEngine}
            style={{ fontSize: "21px" }}
          />
        ) : null}
      </Container>
    );
  },
);
